import { useState } from 'react';
import { useLang } from '../../../i18n/LangContext';

export default function ClientsMap() {
  const [activeRegion, setActiveRegion] = useState<string | null>(null);
  const { t } = useLang();

  const regions = [
    { nameKey: 'region_europe',   clients: 245, color: '#d4af37', top: '35%', left: '48%' },
    { nameKey: 'region_asia',     clients: 156, color: '#f4d03f', top: '45%', left: '75%' },
    { nameKey: 'region_na',       clients: 89,  color: '#d4af37', top: '30%', left: '20%' },
    { nameKey: 'region_sa',       clients: 34,  color: '#f4d03f', top: '65%', left: '28%' },
    { nameKey: 'region_africa',   clients: 28,  color: '#d4af37', top: '55%', left: '50%' },
    { nameKey: 'region_australia',clients: 18,  color: '#f4d03f', top: '70%', left: '82%' },
  ];

  return (
    <section id="clients" className="relative py-24 px-6 bg-gradient-to-b from-[#0a0e1a]/50 to-transparent">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
            {t('map_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">{t('map_subtitle')}</p>
        </div>

        <div className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-8 md:p-12 rounded-3xl border border-[#d4af37]/20">
          <div className="relative w-full" style={{ paddingBottom: '50%' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/0861283e5cd0417958ac6c3ff663356b.jpg"
              alt="World Map"
              className="absolute inset-0 w-full h-full object-contain opacity-40"
            />
            {regions.map((region, index) => (
              <div
                key={index}
                className="absolute transform -translate-x-1/2 -translate-y-1/2 cursor-pointer"
                style={{ top: region.top, left: region.left }}
                onMouseEnter={() => setActiveRegion(region.nameKey)}
                onMouseLeave={() => setActiveRegion(null)}
              >
                <div className="relative">
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center animate-pulse"
                    style={{ backgroundColor: `${region.color}20`, border: `2px solid ${region.color}` }}
                  >
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center font-bold"
                      style={{ backgroundColor: region.color, color: '#0a0e1a' }}
                    >
                      {region.clients}
                    </div>
                  </div>
                  {activeRegion === region.nameKey && (
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 whitespace-nowrap">
                      <div className="bg-[#1a1f35] px-4 py-2 rounded-lg border border-[#d4af37]/50 shadow-xl">
                        <div className="text-[#d4af37] font-semibold">{t(region.nameKey)}</div>
                        <div className="text-gray-300 text-sm">{region.clients} {t('map_clients')}</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {regions.map((region, index) => (
              <div key={index} className="text-center p-4 bg-[#0a0e1a]/50 rounded-xl border border-[#d4af37]/20 hover:border-[#d4af37]/50 transition-all duration-300">
                <div className="text-3xl font-bold text-[#d4af37] mb-1">{region.clients}</div>
                <div className="text-sm text-gray-400">{t(region.nameKey)}</div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <div className="inline-block px-8 py-4 bg-gradient-to-r from-[#d4af37]/10 to-[#f4d03f]/10 rounded-xl border border-[#d4af37]/30">
              <div className="text-5xl font-bold text-[#d4af37] mb-2">570+</div>
              <div className="text-gray-300 text-lg">{t('map_total')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
